var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.params.value !== '(Select All)')?_c('PrioritaetWidget',{class:{ 'kachel-badge-sm': _vm.params.isFilterRenderer },attrs:{"prioritaet":_vm.params.value}}):_c('div',[_vm._v("(Select All)")])
}
var staticRenderFns = []

export { render, staticRenderFns }